import { Input } from "reactstrap"

export const columns = [
    {
      text: (
        <>
          <Input
            type="checkbox"
            className="form-check-input"
            id="Add"
            checked={false}
          />
          &nbsp; Date
        </>
      ),
      dataField: "id",
      style: { minWidth: "150px" },
    },
    {
      text: "Payment Date",
      dataField: "payment_date",
      style: { minWidth: "150px" },
    },
    {
      text: "Payment Amount",
      dataField: "payment_amount",
      style: { minWidth: "150px" },
    },
    {
      text: "Payment Mode",
      dataField: "payment_mode",
      style: { minWidth: "200px" },
    },
    {
      text: "Payment ref",
      dataField: "payment_ref",
      style: { minWidth: "100px" },
    },
  
    {
      text: "Is Balance Only",
      dataField: "is_balance_only",
      style: { minWidth: "250px" },
    },
    {
      text: "Actions",
      dataField: "Actions",
      style: { maxWidth: "90px", minWidth: "70px" },
    },
  ]
